module.exports = __webpack_public_path__ + "95cd5d1d6be4eead4b60f1e0b70e4954.svg";